module.exports = __webpack_public_path__ + "static/media/solar-step-3.45fe6466.png";